import { Card, CardContent, CardOverflow, Typography } from "@mui/joy";
import { Link as TextLink } from '@/components/Link';
import { useParams } from 'react-router-dom';
import { RecipeImage } from './RecipeImage';
import { FavoriteButton } from './FavoriteButton';
import { TriedBadge } from './TriedBadge';
import { memo } from 'react';
import { RecipeDetails } from '@/features/meals/meal-plan/components/RecipeDetails';
import { RecipeCardStats } from './RecipeCardStats';

const ellipsisStyle = { minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" };
const clampStyle = { minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical" };

export const RecipeCard = memo(function RecipeCard({ recipe, orientation = 'vertical', clickable = true, isFavorite = false, isMobile = false }) {
  const { householdId } = useParams();

  const cardSx = orientation === 'vertical' ? {
    border: 'none',    
    overflow: 'hidden',
    boxShadow: 'var(--joy-shadow-sm)',    
    gap: 0,
    
  } : { };
  return (
    <Card variant="outlined" orientation={orientation} component="li" sx={{ width: '100%', flex: 1, ...cardSx }} size='md'>
      <CardOverflow sx={{ position: 'relative' }}>
        <RecipeImage recipe={recipe} orientation={orientation} />        
        { orientation === 'vertical' && <FavoriteButton
          recipeId={recipe.id}
          isFavorite={isFavorite}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            zIndex: 10,                                    
          }}
        />}
      </CardOverflow>
      <CardContent sx={{ minWidth: 0, flex: 1, 
        ...(orientation === 'vertical' && { marginInline: 'calc(-1 * var(--Card-padding))', marginBottom: 'calc(-1 * var(--Card-padding))', padding: '10px 12px', gap: '4px' }) 
      }}>
        <Typography
          level="title-md"
          sx={{ ...(orientation === 'vertical' ? clampStyle : ellipsisStyle) }}
        >
          {clickable ? (
            <TextLink sx={{ color: 'black', display: orientation === 'vertical' ? '-webkit-box' : 'block', ...(orientation === 'vertical' ? clampStyle : ellipsisStyle) }} to={`/h/${householdId}/recipes/${recipe.id}`} overlay underline="none">
              {recipe.name}
            </TextLink>
          ) : recipe.name}
        </Typography>
        {orientation === 'horizontal' && (
          <RecipeDetails recipe={recipe} nutrition={recipe.personalizedNutrition} />
        )}
        {orientation === 'vertical' && <RecipeCardStats recipe={recipe} />}
      </CardContent>
    </Card>
  );
});
